import * as React from 'react';

import { Box, Button, Modal } from '@amzn/awsui-components-react-v3';
import { Link } from 'src/components/common/Link';
import { DGS_ONCALL_URL } from 'src/commons/constants';
import { Page } from 'src/routes';

export interface ConfirmGroupCreationModalProps {
  visible: boolean;
  setVisible: any;
  setRedirect: any;
}

export const ConfirmGroupCreationModal = (props: ConfirmGroupCreationModalProps) => {
  return (
    <Modal
      onDismiss={() => {
        props.setVisible(false);
      }}
      visible={props.visible}
      size='medium'
      footer={
        <Box float='right'>
          <Button
            variant='link'
            onClick={() => {
              props.setVisible(false);
            }}
          >
            Cancel
          </Button>
          <Button variant='primary' onClick={() => props.setRedirect(Page.CREATE_NEW_GROUP)}>
            Confirm
          </Button>
        </Box>
      }
      header='Confirm'
    >
      Are you sure you want to create a new group? This is generally not an encouraged use case, and you should be able
      to accomplish whatever you need from one group. If you have questions, please contact our{' '}
      <Link href={DGS_ONCALL_URL} external={true}>
        oncall
      </Link>{' '}
      for details. If you are sure, click Confirm below to continue.
    </Modal>
  );
};
